angular
    .module('vppApp')
    .service('PageInfoService', PageInfoService);
PageInfoService.$inject = ['$http', '$rootScope'];

function PageInfoService($http, $rootScope) {

    return {
        GetPageInfo:GetPageInfo
    }
    function GetPageInfo(callback) {

        if (!$rootScope.pageInfoContainer) {
            let pageInfoJSON = "./content/json/pageInfo/" + domainAbbr + "/" + domainAbbr + "-pageinfo.json";
            $http.get(pageInfoJSON).then(function(response) {    
                $rootScope.pageInfoContainer =  response.data;
                if (callback !== undefined && typeof callback === 'function') {
                    callback();
                }
            });
        }
        else 
        {
            if (callback !== undefined && typeof callback === 'function') {
                callback();
            }
        }

    }
}